import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate, useAction, fetchApi } from "@inmagik/react-crud"
import type { TextContent } from "../types"
import { API_URL } from "../constants"
import { useAuth } from "../auth"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"

export function useTextsList(params: Record<string, string> = {}) {
  return useList<TextContent>(`${API_URL}/admin/text-contents`, {
    query: params,
  })
}

export function useText(id: number | undefined) {
  return useDetail<TextContent>(`${API_URL}/admin/text-contents`, id?.toString())
}

export function useCreateText() {
  return useCreate<TextContent>(`${API_URL}/admin/text-contents`)
}

export function useUpdateText() {
  return useUpdate<TextContent>(`${API_URL}/admin/text-contents`)
}

export function useDeleteText() {
  return useDelete(`${API_URL}/admin/text-contents`)
}

export function usePartialUpdateText() {
  return usePartialUpdate<TextContent>(`${API_URL}/admin/text-contents`)
}

export function useDeleteMultiText() {
  return useAction(`${API_URL}/admin/text-contents/delete_multi/`, {
    method: "POST",
    responseType: "text",
  })
}

export function useTextLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/text-contents/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<TextContent>
  }, [])
}

export function useTextsLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/text-contents?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: TextContent[] }>
  }, [])
}
